import React from "react";
import Picker from "emoji-picker-react";
import { Trash, X, Smile, Send, ArrowDown, Mail, DollarSign, MoreHorizontal, PlusSquare, Mic, Paperclip, Unlock, Lock } from "react-feather";
import { CTooltip, CButton } from "@coreui/react";
import ReplyMessage from "./ReplyMessage";
import PresetsList from "./PresetsList";
import SliderPaste from "./SliderPaste";
import SliderFiles from "./SliderFiles";
import RecordView from "./RecordView";

function ChatComposer({
  isNewChatChosen,
  isEmojiModalOpen,
  setIsEmojiModalOpen,
  currentReplyMessage,
  closeReplyMessage,
  onEmojiClick,
  isModalPresets,
  presets,
  usePreset,
  isModalpasteImages,
  pasteImagesSlider,
  deletePasteImages,
  isModalSelectedFiles,
  selectedFilesSlider,
  deleteSelectedImages,
  recordTrigger,
  setRecordTrigger,
  currentChatId,
  updateAllChats,
  refreshChatsMeta,
  updateMessagesById,
  getRootProps,
  getInputProps,
  disableUnder24hMessage,
  message,
  handleTyping,
  setMessage,
  handlePasteArchives,
  handlePasteText,
  handleSendEmail,
  // openConsulti, // desativado
  openTemplate,
  openTemplateContract,
  sendMessage,
  isSendingMessage,
  textAreaRef,
  chatInfo,
  inputFileRef,
  handleFiles,
  handleMic,
}) {
  const cursor = { cursor: "help" };
  const allowSendFiles = !(chatInfo?.socialMedia_name === "Facebook" || chatInfo?.socialMedia_name === "Instagram");
  const allowMic = chatInfo?.socialMedia_name !== "Instagram";
  const micEnabled = !!chatInfo?.sessao;
  const micClass = micEnabled ? "action-btn mr-20" : "action-btn action-btn-mic-disable mr-20";

  const sessionInfo = chatInfo?.sessao ? (
    <CTooltip content={"Sua sessao se encerra em " + chatInfo?.repliedAt + "."} placement="right">
      <CButton color="success" type="button" style={cursor}>
        <Unlock color="white" />
      </CButton>
    </CTooltip>
  ) : (
    <CTooltip content="Para poder mandar audio ou texto com quebra de linha, precisa ter uma sessão iniciada com o cliente." placement="right">
      <CButton color="danger" type="button" style={cursor}>
        <Lock color="white" />
      </CButton>
    </CTooltip>
  );

  return (
    <>
      <div className={`media-options ${!isEmojiModalOpen && "display-none"}`}>
        {!isModalpasteImages && !isModalSelectedFiles && !isModalPresets && !currentReplyMessage ? (
          <Picker onEmojiClick={onEmojiClick} pickerStyle={{ width: "100%", height: "300px" }} />
        ) : ""}

        {currentReplyMessage && (
          <ReplyMessage message={currentReplyMessage} closeFn={closeReplyMessage} />
        )}

        {isModalPresets && (
          <PresetsList presets={presets} usePreset={usePreset} />
        )}

        <button style={{ position: "absolute", margin: "95px 0 0 95px" }} className={`action-btn ${!isModalpasteImages && "display-none"}`} onClick={e => { e.preventDefault(); deletePasteImages() }}>
          <Trash size={80} />
        </button>
        {isModalpasteImages && (
          <SliderPaste images={pasteImagesSlider} />
        )}

        <button style={{ position: "absolute", margin: "70px 0 0 70px" }} className={`action-btn  ${!isModalSelectedFiles && "display-none"}`} onClick={e => { e.preventDefault(); deleteSelectedImages() }}>
          <Trash size={80} />
        </button>
        {isModalSelectedFiles && (
          <SliderFiles files={selectedFilesSlider} />
        )}
      </div>

      {isNewChatChosen == false && (
        <form className="actions" {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />

          <RecordView trigger={recordTrigger} setTrigger={setRecordTrigger} chat_id={currentChatId} updateAllChats={updateAllChats} refreshChatsMeta={refreshChatsMeta} updateMessagesById={updateMessagesById} />

          {!recordTrigger && (
            <div className="inner-actions">
              <div className="actions-above">
                <textarea
                  ref={textAreaRef}
                  className="message-input-sender"
                  rows="3"
                  placeholder={disableUnder24hMessage ? "Mensagem desativada" : "Escreva a mensagem..."}
                  value={message}
                  onKeyDown={e => handleTyping(e)}
                  onChange={e => setMessage(e.target.value)}
                  onPaste={e => { handlePasteArchives(e); handlePasteText(e) }}
                  disabled={disableUnder24hMessage}
                />
              </div>
              <div className="actions-below mt-10">
                <div>
                  {sessionInfo}
                </div>
                <div>
                  <button className="action-btn mr-20" onClick={handleSendEmail}>
                    <Mail />
                  </button>

                  <a href="#bottom" className="action-btn mr-20">
                    <ArrowDown />
                  </a>
{/* 
                  {false && (
                    <button className="action-btn mr-20" onClick={e => openConsulti(e)}>
                      <DollarSign />
                    </button>
                  )} */}

                  {!currentReplyMessage && <button className="action-btn mr-20" onClick={openTemplateContract}>
                    <PlusSquare />
                  </button>}

                  {!currentReplyMessage && <button className="action-btn mr-20" onClick={openTemplate}>
                    <MoreHorizontal />
                  </button>}

                  <button className="action-btn mr-20" onClick={e => { e.preventDefault(); setIsEmojiModalOpen(!isEmojiModalOpen) }}>
                    {isEmojiModalOpen ? <X /> : <Smile />}
                  </button>

                  {allowSendFiles && (
                    <label className="action-btn mr-20">
                      <Paperclip />
                      <input
                        hidden
                        ref={inputFileRef}
                        type="file"
                        draggable
                        multiple
                        accept="video/*, image/*, .pdf, audio/*, .ogg, .oga"
                        onChange={e => handleFiles(e)}
                        onDrag={e => handlePasteArchives(e)}
                      />
                    </label>
                  )}

                  {!currentReplyMessage && allowMic && (
                    <button className={micClass} onClick={handleMic} disabled={!micEnabled}>
                      <Mic />
                    </button>
                  )}

                  <button className="action-btn" type="button" onClick={() => sendMessage()} disabled={isSendingMessage}>
                    <Send />
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      )}
    </>
  );
}

export default ChatComposer;
